import Vue from 'vue';
import Vuex from 'vuex';
import modals from '@/store/modules/modals';
import auth from '@/store/modules/auth';
import location from '@/store/modules/location';
import register from '@/store/modules/register';
import recovery from '@/store/modules/recovery';
import rent from '@/store/modules/rent';
import socket from '@/store/modules/socket';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        modals,
        auth,
        location,
        register,
        recovery,
        rent,
        socket
    }
})
